import { Card, Flex, Typography } from 'antd';

import styled from '@emotion/styled';

export const Container = styled(Card)`
  background-color: ${({ theme }) => theme.colors.bgGray};

  .ui-descriptions {
    .ui-descriptions-row {
      &:last-child {
        .ui-descriptions-item {
          padding-bottom: 0;
        }
      }

      .ui-descriptions-item {
        padding-bottom: 12px;

        .ui-descriptions-item-label {
          width: 250px;
        }
      }
    }
  }
`;

export const Header = styled(Flex)`
  margin-bottom: 16px;
`;

export const Title = styled(Typography.Title)`
  .ui-typography {
    margin-bottom: 0;
  }
`;
